module.exports = __webpack_public_path__ + "static/website-349b8d9ecc876e876319db40400e745b.jpg";